import { motion } from 'framer-motion';

const ProblemSection = () => {
  return (
    <section
      id="about"
      className="section-padding relative"
      data-testid="problem-section"
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <p className="section-label mb-5">
            Why AINAA Exists
          </p>

          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0F1B2D] leading-[1.2] tracking-tight">
            Creative professionals deserve
            <span className="block text-[#9B9589] mt-2">
              institutional alliance.
            </span>
          </h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-base sm:text-lg text-[#4A4640] font-medium leading-relaxed mt-10 max-w-2xl mx-auto"
          >
            Artists operate without the safety nets other professions take for granted. No verified credentials. No legal recourse. No financial safety net. AINAA was established to change that — an association that provides the infrastructure creative professionals need to practice their craft with security and recognition.
          </motion.p>
        </motion.div>

        {/* Stat strip */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
          className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 max-w-xl mx-auto"
        >
          {[
            { num: '67%', label: 'of artists lack legal protection' },
            { num: '4 in 5', label: 'have no verified credentials' },
            { num: '89%', label: 'want institutional support' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-['Playfair_Display'] text-2xl sm:text-3xl font-semibold text-[#0F1B2D]">{stat.num}</p>
              <p className="text-xs text-[#9B9589] font-medium mt-1 leading-tight">{stat.label}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;
